import { MessageSquare } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatDateTime, STATUS_LABEL } from "@/lib/utils-task";

const STATUS_STYLES = {
  Pending: "bg-amber-100 text-amber-800 border-amber-200",
  "In-Progress": "bg-indigo-100 text-indigo-800 border-indigo-200",
  Done: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export default function TaskRemarksDialog({ open, onClose, task }) {
  if (!task) return null;
  const remarks = (task.remarks || []).slice().reverse(); // newest first

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="task-remarks-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4" />
            Remark history
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500 truncate">
            {task.title}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[500px] overflow-y-auto -mx-1 px-1">
          {remarks.length === 0 ? (
            <div className="p-8 text-center text-sm text-slate-400">No remarks yet.</div>
          ) : (
            <ol className="relative border-l border-slate-200 ml-3 space-y-5 py-2">
              {remarks.map((r, i) => (
                <li key={i} className="ml-5" data-testid={`remark-entry-${i}`}>
                  <span className="absolute -left-1.5 mt-1 h-3 w-3 rounded-full bg-slate-900 border-2 border-white" />
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span
                      className={`inline-block border text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded ${STATUS_STYLES[r.status] || "bg-slate-100 text-slate-700"}`}
                    >
                      {STATUS_LABEL[r.status] || r.status}
                    </span>
                    <span className="text-xs text-slate-500">
                      by <span className="font-semibold text-slate-700">{r.user_name}</span>
                    </span>
                  </div>
                  <p className="text-sm text-slate-800 leading-relaxed break-words whitespace-pre-wrap">
                    {r.remark}
                  </p>
                  <p className="mt-1 text-[11px] text-slate-400">{formatDateTime(r.created_at)}</p>
                </li>
              ))}
            </ol>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="task-remarks-close">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
